import React from 'react';
import { TextField } from '@mui/material';
import { useCustomApplicationEditor } from '../../../../hooks/useCustomApplicationEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const AppDescriptionEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useCustomApplicationEditor(mode);

  return (
    <TextField
      size="small"
      fullWidth
      multiline
      rows={3}
      label="Description"
      value={request?.description || ''}
      onChange={(e) => updateRequest({ description: e.target.value })}
      placeholder="Provide a detailed description of the application request"
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default AppDescriptionEditor;
